<script setup lang="ts">
import { api } from '@/services';
import { isApiSuccess } from '@/utils/api/functions';

const userStore = useUserStore();

const dialogVisible = defineModel('dialogVisible', { default: false });
const isFinish = ref(false);

async function getCoupon() {
  userStore.isWithdrawCoupon = await userApi.isWithdraw();
  if (userStore.isWithdrawCoupon) {
    return;
  }
  const res = await api.member.withdrawTicket();
  if (isApiSuccess(res)) {
    userStore.isWithdrawCoupon = true;
    userStore.remainingTickets = await userApi.remainingTickets();
    isFinish.value = true;
  }
}

const handleClose = () => {
  dialogVisible.value = false;
};
</script>

<template>
  <div>
    <div class="custom-dialog">
      <el-dialog v-model="dialogVisible" :width="453" :show-close="false" :align-center="true" :z-index="2004">
        <div v-if="!isFinish">
          <div class="dialog-top">
            <img src="/images/free-class.png" alt="" />
          </div>
          <div class="dialog-content">
            <h3>領取 1 堂免費視訊課</h3>
            <p>安排專業顧問為你量身推薦課程</p>
            <div class="dialog-content-button">
              <button @click="handleClose()" class="dialog-content-cancel-button">
                <span>稍後領，再逛逛</span>
              </button>
              <button @click="getCoupon()" class="dialog-content-confirm-button">
                <span>立刻領取</span>
              </button>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="dialog-content">
            <h3>安排成功 🎉</h3>
            <h3>專業顧問將盡快與你聯繫</h3>
            <button @click="handleClose()" class="dialog-content-confirm-button">
              <span>知道了</span>
            </button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<style lang="scss" scoped>
/** style */
.custom-dialog {
  :deep(.el-dialog) {
    padding: 0;
    border-radius: 8px;
  }
  :deep(.el-dialog__header) {
    padding-bottom: 0;
  }
}

.dialog-content {
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;

  line-height: 1.4;
  letter-spacing: 0px;
  color: #191919cc;

  h3 {
    font-weight: 600;
    font-size: 20px;
  }

  p {
    font-weight: 400;
    font-size: 18px;
    color: #f74768;
  }

  .dialog-content-button {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
  }

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    border-radius: 4px;
    outline: none;
    width: 100%;
    padding: 8px 0;
    cursor: pointer;
    margin-top: 20px;
    transition: all 0.3s ease-in;
    border: 1px solid #f74768;

    &.dialog-content-cancel-button {
      background-color: white;
      color: #f74768;

      &:hover {
        color: darken(#f74768, 10%);
      }
    }

    &.dialog-content-confirm-button {
      background-color: #f74768;

      &:hover {
        background-color: darken(#f74768, 10%);
      }
    }

    span {
      font-weight: 400;
      font-size: 16px;
      line-height: 125%;
      letter-spacing: 0px;
    }
  }
}

.dialog-top {
  position: relative;
  height: 240px;
  background-color: #d9d1c6;
  border-radius: 8px 8px 0 0;
  z-index: 1;

  img {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }

  .close {
    position: absolute;
    right: 8px;
    top: 8px;
    color: #19191999;
    cursor: pointer;
    z-index: 1;

    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
